import React from 'react';
import AuthLayout from '../../layouts/AuthLayout';
import PassResetContainer from '../containers/auth/PassResetContainer';

export default () => {
  return (
    <AuthLayout title="Welcome to BRAC Rwanda">
      <PassResetContainer />
    </AuthLayout>
  );
};
